import { getThemeColors } from '../../utils/chartTheme';

export const getOptions = () => {
    const tc = getThemeColors();
    return {
        maintainAspectRatio: true,
        responsive: true,
        title: { display: true, text: '' },
        animation: {
            duration: 750,
            easing: 'easeInOutQuart'
        },
        plugins: {
            tooltip: {
                backgroundColor: 'rgba(33, 37, 41, 0.92)',
                titleColor: '#e4e6ea',
                bodyColor: '#e4e6ea',
                padding: 10,
                cornerRadius: 8,
                displayColors: false,
                callbacks: {
                    label: function (context) {
                        let value = context.dataset.data[context.dataIndex];
                        let date = context.chart.data.labels[context.dataIndex];
                        const watt = Math.round(value);
                        const unit = watt >= 1000 ? `${(watt / 1000).toFixed(1)} kW` : `${watt} W`;
                        return `⚡ ${unit} am ${date}`;
                    }
                }
            },
            legend: { display: false },
            datalabels: {
                display: true,
                anchor: 'end',
                align: 'top',
                color: tc.datalabelColor,
                formatter: (val) => val >= 1000 ? `${(val / 1000).toFixed(1)}` : Math.round(val),
                font: { weight: 'bold', size: 11 }
            },
            peakMarker: { color: '#22c55e' }
        },
        scales: {
            x: {
                grid: { color: tc.gridColor, drawBorder: false },
                ticks: {
                    autoSkip: false,
                    maxRotation: 45,
                    minRotation: 45,
                    color: tc.textColor
                },
                title: {
                    display: true,
                    text: 'Tag',
                    color: tc.textColor
                }
            },
            y: {
                grid: { color: tc.gridColor, drawBorder: false },
                ticks: {
                    beginAtZero: true,
                    color: tc.textColor,
                    callback: (val) => val >= 1000 ? `${val / 1000} kW` : `${val} W`
                },
                title: {
                    display: true,
                    text: 'Leistung',
                    color: tc.textColor
                }
            }
        }
    };
};
